import { opaccAjaxPlugin } from '../opacc.static.js';

/** @module filter */

/**
 * Funktionalität des Filter-Typ "Tablesort".
 */
export class OpaccTablesortFilter {
	/**
	 * Creates an instance of OpaccTableSort.
	 * @param {Object} [selectors={ table: '[data-op-type="tablesort"]', sortDirection: '[data-op-sort-direction]', opSortDirection: 'opSortDirection', opSortAttr: 'opSortAttr', opSortDatatype: 'opSortDatatype', dataMaster: 'data-op-datamaster' }] default selectors
	 */
	constructor(selectors = {
		table: '[data-op-type="tablesort"]',
		sortDirection: '[data-op-sort-direction]',
		opSortDirection: 'opSortDirection',
		opSortAttr: 'opSortAttr',
		opSortDatatype: 'opSortDatatype',
		dataMaster: 'data-op-datamaster',
		dataSortAttr: 'data-op-sort-attr' }) {

		this.doc = document;
		this.win = window;

		this.selectorBaseWrapperElem = 'body';
		this.baseWrapperElem = this.doc.querySelector(this.selectorBaseWrapperElem);

		this.selectorTable = selectors.table;
		this.selectorSortDirection = selectors.sortDirection;
		this.selectorOpSortDirection = selectors.opSortDirection;
		this.selectorOpSortAttr = selectors.opSortAttr;
		this.selectorOpSortDatatype = selectors.opSortDatatype;
		this.selectorDataMaster = selectors.dataMaster;
		this.selectorDataSortAttr = selectors.dataSortAttr;

		this.sortTypes = Object.freeze({
			ASC: 'asc',
			DESC: 'desc'
		});

		this.initEventListener();
	}

	/**
     * Methode initalisiert die Eventlistener.
     * @returns void
     */
	initEventListener() {
		this.baseWrapperElem.addEventListener('click', e => {
			let thElement = e.target.closest(this.selectorSortDirection);
			this.sortTable(thElement);
		});
	}

	/**
     * Methode führt client oder serverseitiges sortieren aus.
     * @param {HTMLElement} thElement Table Header
     */
	sortTable(thElement) {
		if (!thElement) {
			return;
		}

		const table = thElement.closest(this.selectorTable);
		const client = table.getAttribute(this.selectorDataMaster);

		if(client === 'client') { // clientseitiges sortieren
			this.clientTableSort(thElement);
			this.postAsynClientSortState(thElement);
		} else { // serverseitiges sortieren
			this.serverAsynTableSortRequest(thElement);
		}
	}

	/**
     * Methode sortiert den HTML Table local in der DOM.
     * @param {HTMLElement} thElement Table Header
     */
	clientTableSort(thElement) {
		const table = thElement.closest(this.selectorTable);
		const sortAttribut = thElement.dataset[this.selectorOpSortAttr];
		const colDataType = thElement.dataset[this.selectorOpSortDatatype];
		const colIndex = this.getHeaderIndexBySortAttribut(table, sortAttribut);

		this.setOrToggleSortDirection(thElement);
		let sortDirection = thElement.dataset[this.selectorOpSortDirection];

		let rowindex = 0;
		let rows = null;
		let isSorting = true;
		let isSwitching = false;
		let compareCol1  = null;
		let compareCol2 = null;

		while (isSorting) {
			isSorting = false;
			rows = table.rows;

			for (let i = 1; i < rows.length - 1; i++) {
				rowindex = i;
				isSwitching = false;
				compareCol1 = this.getValueFromElement(rows[i].getElementsByTagName('td')[colIndex]);
				compareCol2 = this.getValueFromElement(rows[i + 1].getElementsByTagName('td')[colIndex]);

				if (sortDirection === this.sortTypes.DESC) {
					if(colDataType === 'N') { // typ number
						if (Number(compareCol1) < Number(compareCol2)) {
							isSwitching = true;
							break;
						}
					} else if(colDataType === 'D') { // type date string
						const compare1 = this.convertDINDateStringToISODateNumber(compareCol1);
						const compare2 = this.convertDINDateStringToISODateNumber(compareCol2);
						if (compare1 < compare2) {
							isSwitching = true;
							break;
						}
					} else { // alle anderen typen
						if (compareCol1.toLowerCase() < compareCol2.toLowerCase()) {
							isSwitching = true;
							break;
						}
					}
				} else {
					if(colDataType === 'N') { // typ number
						if (Number(compareCol1) > Number(compareCol2)) {
							isSwitching = true;
							break;
						}
					} else if(colDataType === 'D') { // type date string
						const compare1 = this.convertDINDateStringToISODateNumber(compareCol1);
						const compare2 = this.convertDINDateStringToISODateNumber(compareCol2);
						if (compare1 > compare2) {
							isSwitching = true;
							break;
						}
					} else { // alle andern typen
						if (compareCol1.toLowerCase() > compareCol2.toLowerCase()) {
							isSwitching = true;
							break;
						}
					}
				}
			}

			if (isSwitching) {
				rows[rowindex].parentNode.insertBefore(rows[rowindex + 1], rows[rowindex]);
				isSorting = true;
			}
		}
	}

	/**
     * Methode liefert den geklickten Headerindex per data-op-sort-attr zurück.
     * @param {HTMLElement} table Tabelle
     * @param {string} sortAttribut Sortier Attribut Name
	 * @returns {number} als Index
     */
	getHeaderIndexBySortAttribut(table, sortAttribut) {
		const headers =  table.getElementsByTagName('th');
		for(let i = 0; i < headers.length; i++) {
			const head = headers[i].getAttribute(this.selectorDataSortAttr);

			if(!head) { continue; }

			if(head === sortAttribut) {
				return i;
			}
		}
		return null;
	}

	/**
     * Methode toggelt die sortier direction im data attribut.
     * @param {HTMLElement} thElement Header Element
     */
	setOrToggleSortDirection(thElement) {
		this.removeUnseletectedSortDir(thElement);

		// toggelt direction auf geklickten header spalte
		thElement.dataset[this.selectorOpSortDirection]
            = thElement.dataset[this.selectorOpSortDirection] === this.sortTypes.ASC ? this.sortTypes.DESC : this.sortTypes.ASC;
	}

	/**
     * Methode entfernt die nicht selektierten/geklickten sord direction aus data attribut.
     * @param {HTMLElement} thElement Header Element
     */
	removeUnseletectedSortDir(thElement) {
		// entfert alle direction aus nicht geklickten header spalten
		const sortAttribut = thElement.dataset[this.selectorOpSortAttr];
		const table = thElement.closest(this.selectorTable);
		let headers =  table.querySelectorAll(this.selectorSortDirection);

		for(let header of headers) {
			const headerSortAttr = header.dataset[this.selectorOpSortAttr];
			if(headerSortAttr === sortAttribut) {
				continue;
			}

			header.dataset[this.selectorOpSortDirection] = '';
		}
	}

	/**
     * Methode konvertiert einen DIN Date-String (31.12.2020) und liefert ISO Date als Number (20201231) zurück.
     * Hinweis: Das deutsche DIN Datumsformat (31.12.2020) kann nicht mit Date() geparst werden und muss mittels separator gesplittet werden,
     *          ändert der Separator funktioniert die konvertierung nicht mehr.
     * @param {string} dateString Datum als string
	 * @returns {string} ISO datum als String
     */
	convertDINDateStringToISODateNumber(dateString) {
		const dateSplit = dateString.split('.');
		if(dateSplit.length === 0) { return 0; }

		const rev = Number(`${dateSplit[2]}${dateSplit[1]}${dateSplit[0]}`);
		return rev;
	}

	/**
     * Methode durchläuft rekursiv alle child elemente und liefert das value vom letzten element zurück.
     * @param {HTMLElement} element element mit Value
	 * @returns {string} value als string
     */
	getValueFromElement(element) {
		let value = '';
		for(let child of element.childNodes) {
			if(child.childNodes.length > 0) {
				return this.getValueFromElement(child);
			} else {
				value = child.nodeValue;
				break;
			}
		}
		return value ? value : '';
	}

	/**
	 * Methde für den asynchronen Request für den Tabel Sort aus.
	 * @param {HTMLElement} thElement Table Header
	 */
	serverAsynTableSortRequest(thElement) {
		this.setOrToggleSortDirection(thElement);
		const url = window.location.href;
		let options = this.getAsynPostOptions(thElement);
		opaccAjaxPlugin.fetchAsynPostForm(url, options, this.asyncTableSortHandler.bind(this), this.asyncErrorHandler.bind(this), true);
	}

	/**
	 * Methode poste Poste den sortierstatus von der Clientseitigen sortierung an den Server.
	 * Es wird kein Response ausgewertet.
	 * @param {HTMLElement} thElement Table Header
	 */
	postAsynClientSortState(thElement) {
		const url = window.location.href;
		let options = this.getAsynPostOptions(thElement);
		opaccAjaxPlugin.fetchAsynPostForm(url, options, () => { this.removeFetchLoaderFrame(); }, this.asyncErrorHandler.bind(this), true);
	}

	/**
	 * Methode liefert die Options für den asynchronen request.
	 * @param {HTMLElement} thElement Table Header
	 */
	getAsynPostOptions(thElement) {
		this.showFetchLoaderFrame(thElement);
		const table = thElement.closest(this.selectorTable);
		const client = table.getAttribute(this.selectorDataMaster);
		const sortAttribut = thElement.dataset[this.selectorOpSortAttr];
		const sortDirection = thElement.dataset[this.selectorOpSortDirection];

		let options = { };
		options['type'] = 'tablesort';
		options['clientSort'] = client ? true : false;
		options['tableid'] = table.id;
		options['sorting'] = `{"${sortAttribut}":"${sortDirection}"}`;

		return options;
	}

	/**
	 * Methde verarbeitet und rendert den Response vom asynchronen table sort.
	 * @param {Object} response
	 */
	asyncTableSortHandler(response) {
		if (!response.success && !response.dataAsHtml) {
			return;
		}

		this.replaceAllResponseTable(response.dataAsHtml);
		this.removeFetchLoaderFrame();
	}

	/**
	 * Methode ersetzt alle Response/Sortierten Tables mit dem Tables in der DOM.
	 * @param {string} dataAsHtml String vom Typ HTML
	 */
	replaceAllResponseTable(dataAsHtml) {
		const html = new DOMParser().parseFromString(dataAsHtml, 'text/html');
		const oldTables = this.baseWrapperElem.querySelectorAll(this.selectorTable);
		const newTables = html.querySelectorAll(this.selectorTable);

		for(let oldTable of oldTables) {
			for(let newTable of newTables) {
				if(oldTable.id === newTable.id) {
					oldTable.parentNode.replaceChild(newTable, oldTable);
					break;
				}
			}
		}
	}

	/**
	 * Methode zeigt das loader frame und blockiert während des response den table.
	 * @param {HTMLElement} thElement
	 */
	showFetchLoaderFrame(thElement) {
		const table = thElement.closest(this.selectorTable);
		const height = table.offsetHeight;
		const width = table.offsetWidth;

		let loader = document.createElement('div');
		loader.classList.add('fetch-loader-frame');
		loader.dataset.forTableId = table.id;
		loader.style.width = width + 'px';
		loader.style.height = height + 'px';

		let spinner = document.createElement('div');
		spinner.classList.add('loader');
		loader.appendChild(spinner);

		table.before(loader);
	}

	/**
	 * Methode enfernt den loader aus der DOM.
	 */
	removeFetchLoaderFrame() {
		const loaders = this.baseWrapperElem.querySelectorAll('.fetch-loader-frame');

		if(!loaders && !loaders.length) { return; }

		for(let loader of loaders) {
			loader.remove();
		}
	}

	/**
	 * Methde verarbeitet den Fehler-Response vom asynchronen table sort.
	 * @param {Object} error
	 */
	asyncErrorHandler(error) {
		this.removeFetchLoaderFrame();
		// eslint-disable-next-line no-console
		console.error('Request failed: ', error.message);
	}
}